import { render, staticRenderFns } from "./EndorsementContractInsured.vue?vue&type=template&id=69684424&scoped=true"
import script from "./EndorsementContractInsured.vue?vue&type=script&lang=js"
export * from "./EndorsementContractInsured.vue?vue&type=script&lang=js"
import style0 from "./EndorsementContractInsured.vue?vue&type=style&index=0&id=69684424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69684424",
  null
  
)

export default component.exports